import type { ChatMentionsMenuItemType } from '@terra/ui-design-system';
import { createObjectContextMention } from './objectContextMentionUtils';
import { truncateBodyForChat } from './httpFormatter';

export function createChatSelectionMention({
  chatId,
  chatTitle,
  excerpt,
}: {
  chatId: string;
  chatTitle: string;
  excerpt: string;
}): ChatMentionsMenuItemType {
  const trimmedExcerpt = excerpt.trim();

  return createObjectContextMention({
    objectKind: 'Chat',
    objectId: chatId,
    objectLabel: chatTitle,
    selection: {
      excerpt: truncateBodyForChat(trimmedExcerpt) ?? trimmedExcerpt,
    },
  });
}
